// eslint-disable-next-line import/no-cycle
import { ComponentNameEnum, FieldConfig } from '@/types';

/**
 * Read-only notice displayed between the fields of a group, rendered with the configuration panel NoticeBox.
 * @param label i18n key of the message
 * @param severity notice color, 'info' by default
 */
const getNoticeFieldConfig = (label: string, severity: 'info' | 'warning' | 'danger' = 'info'): FieldConfig => ({
  label,
  selector: '',
  properties: [],
  componentName: ComponentNameEnum.NOTICE,
  options: {
    severity,
  },
});

export default getNoticeFieldConfig;
